var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import { LessonType } from '@/models/LessonType';
import { lessonTypeIcons } from '@/support/Icon';
let EditLessonTypeDialog = class EditLessonTypeDialog extends Vue {
    constructor() {
        super(...arguments);
        this.lessonTypeIcons = null;
        this.selectedLessonTypeIcon = '';
        this.lessonName = '';
    }
    mounted() {
        this.lessonTypeIcons = lessonTypeIcons;
    }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    update() {
        this.lessonType
            .update({
            name: this.lessonName,
            icon: this.selectedLessonTypeIcon,
        })
            .then(() => {
            this.$emit('input', false);
            this.$emit('lessonTypeUpdated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    clear() {
        if (this.lessonType.name) {
            this.lessonName = this.lessonType.name;
        }
    }
    lessonTypeChange(lessonType) {
        if (lessonType.name) {
            this.lessonName = lessonType.name;
        }
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof LessonType !== "undefined" && LessonType) === "function" ? _a : Object)
], EditLessonTypeDialog.prototype, "lessonType", void 0);
__decorate([
    Watch('lessonType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof LessonType !== "undefined" && LessonType) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], EditLessonTypeDialog.prototype, "lessonTypeChange", null);
EditLessonTypeDialog = __decorate([
    Component({
        components: {
        //
        },
    })
], EditLessonTypeDialog);
export default EditLessonTypeDialog;
